<template>
  <div class="diet-calendar">
    <div class="diet-top">
      <!-- 用户信息 -->
      <div class="user-info" v-if="userinfo">
        <img class="avatar" :src="userinfo.u_img" alt="" />
        <div class="user-right">
          <p class="nickname">{{ userinfo.remark_name || userinfo.u_name }}</p>
          <p class="camp">{{ userinfo.alias }}</p>
        </div>
      </div>
      <div class="s-content">
        <div class="s-item" @click="bindBefore">
          <span class="before iconfont icon-xiala"></span
          ><span>{{ beforeMonth }}月</span>
        </div>
        <div class="s-title">{{ curYear }}年{{ curMonth }}月</div>
        <div class="s-item" @click="bindAfter">
          <span>{{ afterMonth }}月</span
          ><span class="after iconfont icon-xiala"></span>
        </div>
      </div>
      <div>
        <van-calendar
          v-if="showCalendar"
          :show-title="false"
          :show-subtitle="false"
          :show-mark="false"
          :min-date="calendarData.minDate"
          :max-date="calendarData.maxDate"
          :default-date="calendarData.default"
          :poppable="false"
          :show-confirm="false"
          :formatter="formatter"
          @select="bindSelctCalendar"
        />
      </div>
      <div class="diet-info">
        <div class="d-item">
          <div class="d-title">打卡天数</div>
          <div class="d-num">
            {{ (dietInfo && dietInfo.total_days) || '-' }}天
          </div>
        </div>
        <div class="d-item">
          <div class="d-title">打卡次数</div>
          <div class="d-num">
            {{ (dietInfo && dietInfo.total_count) || '-' }}次
          </div>
        </div>
        <div class="d-item">
          <div class="d-title">打卡效率</div>
          <div class="d-num">
            {{ (dietInfo && dietInfo.total_rate) || '-' }}
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="diet-container" v-if="dietData">
      <div class="day-item">
        <div class="day-top" v-if="dietData.day || dietData.day === 0">
          <span class="day">{{ dietData.day | filterDay }}</span>
          <span class="time">{{ dietData.date }}</span>
        </div>
        <div class="meal-list">
          <div
            class="meal-item"
            v-for="(item1, index1) in dietData.list"
            :key="index1"
          >
            <div class="left-line">
              <div class="dot"></div>
              <div class="line"></div>
            </div>
            <div class="meal-top">
              <span class="name">{{ item1.curMeal | filterMeal }}</span>
              <span class="time">{{ item1.addtime | filterAddTime }}</span>
              <span class="score">{{
                item1.p_average_score | filterScore
              }}</span>
            </div>
            <div class="meal-say">{{ item1.say }}</div>
            <div class="meal-image-list">
              <img
                class="meal-image-item"
                :src="imageitem"
                alt=""
                v-for="(imageitem, imageindex) in item1.content"
                :key="imageindex"
                v-show="imageindex < 4"
                @click="bindPreviewImage(item1.content, imageindex)"
              />
              <div class="image-count" v-if="item1.content.length > 4">
                +{{ item1.content.length - 4 }}
              </div>
            </div>
            <div class="meal-tag">
              <span
                class="meal-tag-item"
                v-for="(tagitem, tagindex) in item1.p_label"
                :style="{ color: filterTag(tagitem.type) }"
                :key="tagindex"
                >{{ tagitem.label }}</span
              >
            </div>
          </div>
        </div>
        <div class="not-data" v-if="!dietData.list.length">暂无数据</div>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
export default {
  data() {
    return {
      unify_id: 5229,
      pid: '', //营期id
      show: true,
      showCalendar: false,
      /*  */
      calendarData: {
        maxTime: '', //最大年月
        minTime: '', //最小年月
        curTime: '', //当前年月
        minDate: '', //日历组件的最小时间
        maxDate: '', //日历组件的最大时间
        default: '' //默认选中时间
      },
      dietInfo: null,
      dietData: null,
      userinfo: null
    }
  },
  filters: {
    filterMeal(curMeal) {
      curMeal = curMeal || 0
      let obj = {
        3: ['早餐卡', '午餐卡', '晚餐卡', '加餐卡']
      }
      return obj[3][curMeal]
    },
    filterScore(score) {
      if (score || score === 0) {
        return score + '分'
      }
      return ''
    },
    filterAddTime(str = '') {
      return str.split(' ')[1] || ''
    },
    filterDay(day) {
      if (day == '观察期') {
        return day
      }
      return '第' + day + '天'
    }
  },
  computed: {
    beforeMonth() {
      let curTime = this.calendarData.curTime
      let curMonth = parseInt(curTime.split('-')[1])
      let beforeMonth = --curMonth
      return beforeMonth || 12
    },
    afterMonth() {
      let curTime = this.calendarData.curTime
      let curMonth = parseInt(curTime.split('-')[1])
      let afterMonth = ++curMonth
      return afterMonth % 12 || 12
    },
    curMonth() {
      let curTime = this.calendarData.curTime
      return curTime.split('-')[1]
    },
    curYear() {
      let curTime = this.calendarData.curTime
      return curTime.split('-')[0]
    }
  },
  created() {
    this.init()
    let now = new Date()
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    month = month < 10 ? '0' + month : month
    let date = now.getDate()
    date = date < 10 ? '0' + date : date
    let dayStr = year + '-' + month + '-' + date
    this.getDietDataByDay(dayStr)
    let monthStr = year + '-' + month
    this.getDietInfo(monthStr)
    this.getDetail()
  },
  methods: {
    init() {
      this.unify_id = this.$route.query.unifyId || ''
      this.pid = this.$route.query.pid || ''
      let cur = new Date()
      let year = cur.getFullYear()
      let month = cur.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let date = cur.getDate()
      date = date < 10 ? '0' + date : date
      let monthTime = year + '-' + month
      let dayTime = year + '-' + month + '-' + date
      this.calendarData.maxTime = dayTime
      this.calendarData.curTime = dayTime
      this.calendarData.minDate = new Date(this.dealIOS(monthTime + '-01'))
      this.calendarData.maxDate = new Date(this.dealIOS(dayTime))
      this.calendarData.default = new Date(this.dealIOS(dayTime))
    },
    //处理ios时间字符串中带-转换失败的问题
    dealIOS(str) {
      return str.replace(/-/g, '/')
    },
    filterTag(type) {
      let arr = [
        'rgba(43, 183, 155, 1)',
        'rgba(240, 70, 70, 1)',
        'rgba(0, 0, 0, 1)'
      ]
      let index = type - 1
      index = index < 0 ? 0 : index
      return arr[index] || arr[arr.length - 1]
    },
    getDetail() {
      let params = {
        gid: this.$route.query.id,
        tab_type: this.$route.query.tabType
      }
      this.$http
        .getApp('member/CampUgc/getCampUgcDetailToDietitian', params)
        .then((res) => {
          res = res.data
          console.log(res)
          if (res.code == 200) {
            this.userinfo = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    bindBefore() {
      if (
        new Date(this.calendarData.minDate) <=
        new Date(this.dealIOS(this.calendarData.minTime))
      ) {
        this.$toast('不能再后退了')
        return
      }
      let curYear = this.curYear
      let curMonth = this.curMonth
      let beforeMonth = --curMonth
      if (beforeMonth <= 0) {
        curYear--
        curMonth = 12
      }
      let date = this.calendarData.curTime.split('-')[2]
      this.calendarData.curTime =
        curYear + '-' + (curMonth < 10 ? '0' + curMonth : curMonth) + '-' + date
      this.updateCalendarRange(curYear, curMonth, date)
    },
    bindAfter() {
      if (
        new Date(this.calendarData.maxDate) >=
        new Date(this.dealIOS(this.calendarData.maxTime))
      ) {
        this.$toast('不能再前进了')
        return
      }
      let curYear = this.curYear
      let curMonth = this.curMonth
      let afterMonth = ++curMonth
      console.log(this.curYear, this.curMonth)
      if (afterMonth > 12) {
        curYear++
        curMonth = 1
      }
      let date = this.calendarData.curTime.split('-')[2]
      this.calendarData.curTime =
        curYear + '-' + (curMonth < 10 ? '0' + curMonth : curMonth) + '-' + date
      this.updateCalendarRange(curYear, curMonth, date)
    },
    bindPreviewImage(list, index) {
      ImagePreview({
        images: list,
        startPosition: index
      })
    },
    //更新日历区间
    updateCalendarRange(curYear, curMonth) {
      curYear = parseInt(curYear)
      curMonth = parseInt(curMonth)
      let nextMonth = curMonth + 1
      let nextYear = curYear
      if (nextMonth > 12) {
        nextYear = curYear + 1
        nextMonth = 1
      }
      //兼容ios 时间/
      let nextTime = new Date(nextYear + '/' + nextMonth + '/01') //下个月一号
      let lastDay = nextTime.getTime() - 1000 * 60 * 60 * 24 //这个月最后一天
      lastDay = new Date(lastDay).getDate()
      console.log(this.calendarData)
      this.calendarData.minDate = new Date(curYear + '/' + curMonth + '/01')
      this.calendarData.maxDate = new Date(
        curYear + '/' + curMonth + '/' + lastDay
      )
      let yearMonth = this.calendarData.curTime.slice(0, 7)
      this.getDietInfo(yearMonth)
    },
    onConfirm() {},
    //选中日期时
    bindSelctCalendar(value) {
      let year = value.getFullYear()
      let month = value.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let date = value.getDate()
      date = date < 10 ? '0' + date : date
      let str = year + '-' + month + '-' + date
      this.getDietDataByDay(str)
    },
    formatter(day) {
      const year = day.date.getFullYear()
      const month = day.date.getMonth() + 1
      const date = day.date.getDate()
      let now = new Date()
      if (
        year == now.getFullYear() &&
        month == now.getMonth() + 1 &&
        date == now.getDate()
      ) {
        day.className = 'today'
      }
      //this.dietInfo.all_month_data
      for (let i = 0; i < this.dietInfo.all_month_data.length; i++) {
        let item = this.dietInfo.all_month_data[i]
        let itemTime = new Date(this.dealIOS(item.curDate))
        let itemyear = itemTime.getFullYear()
        let itemmonth = itemTime.getMonth() + 1
        let itemdate = itemTime.getDate()
        if (year == itemyear && month == itemmonth && date == itemdate) {
          day.bottomInfo = item.c_count + '次'
          break
        }
      }
      return day
    },
    getDietDataByDay(str) {
      let params = {
        date: str,
        unify_id: this.unify_id,
        pid: this.pid
      }
      this.$http
        .getApp(
          'member/NutritionistComments/getUserMealCardRecordByDate',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.dietData = this.dealData(res.data || {})
          }
        })
    },
    dealData(data) {
      if (data.list && Array.isArray(data.list)) {
        data.list.map((item) => {
          item.content = item.content.split(',') || []
        })
      }
      return data
    },
    getDietInfo(str) {
      let params = {
        month: str,
        unify_id: this.unify_id,
        pid: this.pid
      }
      this.$http
        .getApp(
          'member/NutritionistComments/getUserMonthMealCardStatistics',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.dietInfo = res.data
            this.calendarData.minTime = this.computedMinTime(
              this.dealIOS(res.data.s_date)
            )
            this.showCalendar = true
          }
        })
    },
    computedMinTime(str) {
      let start = new Date(str).getTime()
      //开始时间减去两天 需要包含观察期
      start = start - 2 * 1000 * 60 * 60 * 24
      start = new Date(start)
      let year = start.getFullYear()
      let month = start.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = start.getDate()
      day = day < 10 ? '0' + day : day
      return year + '-' + month + '-' + day
    }
  }
}
</script>
<style lang="scss">
.diet-calendar {
  .van-calendar__month-title {
    display: none;
  }
  .van-calendar__header {
    box-shadow: none;
  }
  .van-calendar__day {
    font-size: 16px;
    font-family: DIN-Medium, DIN;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 19px;
  }
  .van-calendar__body {
    overflow: hidden;
  }
  .van-calendar__selected-day {
    background: #6236ff;
    border-radius: 8px;
    padding: 6px 9px;
    .van-calendar__bottom-info {
      color: #ffffff;
    }
  }
  .today {
    color: rgba(98, 54, 255, 1);
  }
  .van-calendar__day--disabled {
    color: #c8c9cc;
  }
  .van-calendar__bottom-info {
    font-size: 9px;
    font-family: DIN-Medium, DIN;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.5);
    line-height: 11px;
  }
}
</style>
<style lang="scss" scoped>
.diet-calendar {
  padding: 10px 0px;
  .diet-top {
    padding: 0px 20px 20px;
    border-bottom: 1px solid #eee;
  }
  .user-info {
    display: flex;
    align-content: center;
    margin-bottom: 16px;
    .avatar {
      width: 36px;
      height: 36px;
      border-radius: 6px;
      overflow: hidden;
      margin-right: 10px;
    }
    .user-right {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      .nickname {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 17px;
      }
      .camp {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        line-height: 14px;
      }
    }
  }
  .s-content {
    display: flex;
    align-items: center;
    height: 32px;
    background: #6236ff;
    border-radius: 10px;
    padding: 0px 20px;
    .s-item {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(255, 255, 255, 0.5);
      line-height: 20px;
      .before {
        display: inline-block;
        transform: rotate(90deg);
      }
      .after {
        display: inline-block;
        transform: rotate(-90deg);
      }
    }
    .s-title {
      text-align: center;
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
    }
  }
  .diet-info {
    padding: 7px 10px 10px;
    background: #f7f7f7;
    border-radius: 8px;
    border: 1px solid #f1f1f1;
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-align: center;
    .d-item {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
    }
    .d-title {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      margin-bottom: 7px;
    }
    .d-num {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
    }
  }
  .diet-container {
    padding: 20px;
    .day-item {
      .day-top {
        margin-bottom: 16px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 25px;
        .day {
          margin-right: 13px;
        }
      }
      .meal-list {
        .meal-item {
          position: relative;
          padding-bottom: 34px;
          padding-left: 26px;
          .left-line {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            .dot {
              width: 16px;
              height: 16px;
              box-sizing: border-box;
              background: #ffffff;
              border-radius: 50%;
              border: 3px solid #6236ff;
            }
            .line {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              width: 1px;
              background-color: #f1f1f1;
            }
          }
          .meal-top {
            margin-bottom: 9px;
            .name {
              font-size: 16px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              line-height: 22px;
              margin-right: 10px;
            }
            .time {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 20px;
              margin-right: 13px;
            }
            .score {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #6236ff;
              line-height: 22px;
            }
          }
          .meal-say {
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.5);
            line-height: 22px;
            margin-bottom: 16px;
          }
          .meal-image-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            position: relative;
            .image-count {
              padding: 0px 8px;
              height: 30px;
              line-height: 30px;
              background: rgba(0, 0, 0, 0.8);
              border-radius: 7px;
              position: absolute;
              bottom: 18px;
              right: 8px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
            }
            .meal-image-item {
              width: 150px;
              height: 150px;
              background: #f1f1f1;
              border-radius: 8px;
              overflow: hidden;
              margin-bottom: 10px;
              margin-right: 8px;
              object-fit: cover;
            }
            .meal-image-item:nth-child(2n) {
              margin-right: 0;
            }
          }
          .meal-tag {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .meal-tag-item {
              padding: 0px 20px;
              height: 24px;
              line-height: 24px;
              background: #f9f9f9;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              border-radius: 4px;
              margin-right: 6px;
              margin-bottom: 4px;
            }
          }
        }
      }
    }
  }
}
.not-data {
  margin-top: 20px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}
</style>
